import flights_web_cat_fly_anywhere_map_view_www from "../../../../utils/experiments/cat/flights_web_cat_fly_anywhere_map_view_www.js";
import flights_web_cat_fly_anywhere_map_view_mdot from "../../../../utils/experiments/cat/flights_web_cat_fly_anywhere_map_view_mdot.js";
import useUserAgent from "../../../../hooks/useUserAgent.js";
export const useIsMapViewExp = () => {
    const { isMobile } = useUserAgent();
    const utils = isMobile ? flights_web_cat_fly_anywhere_map_view_mdot : flights_web_cat_fly_anywhere_map_view_www;
    return !!utils.trackWithDefaultStage();
};
